import {
  IonActionSheet,
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonLabel,
  IonPage,
  useIonViewWillEnter,
} from '@ionic/react';

import { addOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useBle } from 'src/ble/useBle';
import { selectAuthUserInfo } from 'src/redux/auth/selectors';
import { BleConnectionState } from 'src/redux/ble/constants';
import { useHasPermission } from 'src/utils/PermissionGuard';
import LinkCardList from '../../components/home/LinkCardList';
import MobileHomeSummaryTiles from '../../components/home/MobileHomeSummaryTiles';
import MobileRecentActivityContainer from '../../components/home/MobileRecentActivityContainer';
import MobileHeader from '../../components/reusable-components/MobileHeader';
import { GenericMessages } from '../../intl/GenericMessages';
import { HomeMessages } from '../../intl/HomeMessages';
import { appBarActions } from '../../redux/appBar/actions';
import { MobileLogListPageActions } from '../jobs/MobileLogsListPage';

import './MobileHomePage.scss';
import { JobSyncSlide } from 'src/components/job-sync-slide/JobSyncSlide';
import { AppRouteConstants } from '../app-layout/AppRouteConstants';
import { DqDivider } from 'src/components/DqDivider';
import ConnectedControllerCard from 'src/components/connected-controller/ConnectedControllerCard';
import { useHasBluetoothLE } from 'src/utils/helpers/platformHelpers';
import { bleActions } from 'src/redux/ble/actions';

export const MobileHomePage: React.FC = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();
  const [showActionSheet, setShowActionSheet] = useState<boolean>(false);
  const { bleState } = useBle();
  const userData = useSelector(selectAuthUserInfo);
  const hasBluetooth = useHasBluetoothLE();

  useIonViewWillEnter(() => {
    dispatch(appBarActions.setTitle(formatMessage(HomeMessages.homeHeader)));
    dispatch(appBarActions.showBack(false));
  }, [dispatch, formatMessage]);

  const buttons = [
    {
      text: formatMessage(GenericMessages.cancelButtonLabel),
      handler: () => {
        setShowActionSheet(false);
      },
    },
  ];

  const canUploadJobLog = useHasPermission('UploadJobLog');

  if (bleState === BleConnectionState.CONNECTED && canUploadJobLog) {
    buttons.unshift({
      text: formatMessage(HomeMessages.homeMenuUploadLogLabel),
      handler: () => {
        history.push(AppRouteConstants.LogsList, { action: MobileLogListPageActions.Upload });
      },
    });
  }

  const hasActionItems = buttons.length > 1;
  return (
    <IonPage>
      <MobileHeader />
      <IonContent>
        <JobSyncSlide className="ion-margin-bottom" />
        {bleState !== BleConnectionState.CONNECTED && hasBluetooth && (
          <IonButton
            className="ion-margin-vertical"
            expand="block"
            color="primary"
            fill="solid"
            onClick={() => {
              dispatch(bleActions.openConnectControllerModal());
            }}
          >
            <IonLabel>{formatMessage(HomeMessages.connectToController)}</IonLabel>
          </IonButton>
        )}
        {bleState === BleConnectionState.CONNECTED && (
          <div className="ion-margin-vertical">
            <ConnectedControllerCard />
          </div>
        )}
        <MobileHomeSummaryTiles />
        <MobileRecentActivityContainer userData={userData} />
        <div className="ion-margin-top">
          <DqDivider title={formatMessage(HomeMessages.homeStoneAgeResourcesTitle)} />
        </div>
        <LinkCardList />
        {hasActionItems && (
          <>
            <IonFab vertical="bottom" horizontal="end" slot="fixed">
              <IonFabButton onClick={() => setShowActionSheet(true)}>
                <IonIcon icon={addOutline} />
              </IonFabButton>
            </IonFab>
            <IonActionSheet isOpen={showActionSheet} onDidDismiss={() => setShowActionSheet(false)} buttons={buttons} />
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default MobileHomePage;
